import { SvgIcon } from "@material-ui/core";
export const altitudeIcon = (
  <SvgIcon>
    <svg version="1.1" viewBox="0 0 29 22" id="svg14" xmlns="http://www.w3.org/2000/svg">
      <defs id="defs18" />
      <path
        style={{ fill: "#000000", strokeWidth: 0.264583 }}
        id="path239"
        d="M 13.109271,7.4757552 11.397404,4.3257374 9.6855368,1.1757197 l 3.5839292,0.092489 3.583929,0.092489 -1.872062,3.0575292 z"
        transform="matrix(-3.065936,0.0613677,-0.06480573,-2.9032843,58.790206,24.281499)"
      />
      <path
        id="path448"
        style={{ fill: "#ffffff", strokeWidth: 0.264583 }}
        d="m 20.825316,12.628686 -1.460689,-1.628837 -1.396117,2.029324 -1.441563,-2.128169 -1.281748,1.887877 -1.396116,-1.601758 4.33302,-6.9953608 4.111476,6.9340108 z"
      />
      <rect
        style={{ fill: "#000000", strokeWidth: 0.264583 }}
        id="rect503"
        width="1.5752481"
        height="15.2185"
        x="3.6577797"
        y="6.1140995"
      />
      <path
        style={{ fill: "#000000", strokeWidth: 0.264583 }}
        id="path505"
        d="M 6.0073029,3.65778 2.5178646,3.8568678 -0.97157379,4.0559555 0.60073031,0.93446946 2.1730345,-2.1870167 4.0901687,0.7353816 Z"
        transform="matrix(0.99800931,0.04283307,-0.06306681,0.67781776,2.2034994,4.5623512)"
      />
      <rect
        style={{ fill: "#000000", strokeWidth: 0.264583 }}
        id="rect507"
        width="5.6335154"
        height="1.3616554"
        x="1.2281598"
        y="19.970945"
      />
      <rect
        style={{ fill: "#000000", strokeWidth: 0.264583 }}
        id="rect509"
        width="1.0412658"
        height="1.1480623"
        x="2.7233107"
        y="13.269465"
      />
      <rect
        style={{ fill: "#000000", strokeWidth: 0.264583 }}
        id="rect511"
        width="1.067965"
        height="1.2014606"
        x="2.6966116"
        y="16.633554"
      />
      <rect
        style={{ fill: "#000000", strokeWidth: 0.264583 }}
        id="rect513"
        width="1.3082571"
        height="1.1747615"
        x="2.6966116"
        y="9.8252773"
      />
    </svg>
  </SvgIcon>
);
